import { useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { SCRIPT_SRC, loginTawkChat } from '@/lib/tawk';

export default function TawkChat() {
  const { user, mfaRequired } = useAuth();
  const userId = user?.id;

  useEffect(() => {
    if (window.Tawk_API) {
      void loginTawkChat();
      return;
    }
    window.Tawk_API = { onLoad: () => void loginTawkChat() };
    window.Tawk_LoadStart = new Date();
    const script = document.createElement('script');
    script.async = true;
    script.src = SCRIPT_SRC;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);
  }, [userId, mfaRequired]);

  return null;
}
